// eventUtils.js

// ---------- Impact ----------
export const IMPACT = { LOW: "low", MEDIUM: "medium", HIGH: "high" };

const SCORE = { low: 1, medium: 2, high: 3 };

export const impactScore = (v) =>
  typeof v === "number" ? (v >= 1 && v <= 3 ? v : 0) : SCORE[String(v || "").toLowerCase()] || 0;

export const impactLabel = (v) =>
  ({ 1: "Low", 2: "Medium", 3: "High" }[impactScore(v)] || "");

// ---------- Status ----------
export const EVENTSTATUS = {
  UPCOMING: "UPCOMING",
  PENDING: "PENDING",
  ONGOING: "ONGOING",
  OVERDUE: "OVERDUE",
  COMPLETED: "COMPLETED",
  CLOSED: "CLOSED",
  ACKNOWLEDGED: "ACKNOWLEDGED",
};

// Colors
const STATUS_COLORS = {
  [EVENTSTATUS.UPCOMING]: "#6C757D",
  [EVENTSTATUS.PENDING]: "#F09D4F",
  [EVENTSTATUS.ONGOING]: "#007BA7",
  [EVENTSTATUS.OVERDUE]: "#FF6B6B",
  [EVENTSTATUS.COMPLETED]: "#28a745",
  [EVENTSTATUS.CLOSED]: "#28a745",
  [EVENTSTATUS.ACKNOWLEDGED]: "#6F42C1",
};

// Display labels
const STATUS_DISPLAY = {
  [EVENTSTATUS.UPCOMING]: "Upcoming",
  [EVENTSTATUS.PENDING]: "Pending",
  [EVENTSTATUS.ONGOING]: "Ongoing",
  [EVENTSTATUS.OVERDUE]: "Overdue",
  [EVENTSTATUS.COMPLETED]: "Completed",
  [EVENTSTATUS.CLOSED]: "Closed",
  [EVENTSTATUS.ACKNOWLEDGED]: "Acknowledged",
};

const normalizeStatus = (status) => String(status || "").toUpperCase();

export const getStatusColor = (status) => {
  const key = normalizeStatus(status);
  return STATUS_COLORS[key] || STATUS_COLORS[EVENTSTATUS.UPCOMING];
};

export const getStatusDisplay = (status) => {
  const key = normalizeStatus(status);
  return STATUS_DISPLAY[key] || status;
};

export const getStatus = (status) => ({
  color: getStatusColor(status),
  display: getStatusDisplay(status),
});

// ---------- Ack helper ----------
export const parseAck = (v) => {
  if (!v) return [];
  if (Array.isArray(v)) return v;
  try {
    const j = JSON.parse(v);
    return Array.isArray(j) ? j : [];
  } catch {
    return [];
  }
};

export const getLatestAckMeta = (ack) => {
  const arr = parseAck(ack);
  if (!arr.length) return undefined;
  const last = arr[arr.length - 1];
  return {
    user: last.user || last.username || last.name || "",
    comment: last.comment || "",
    date: last.date || last.datetime || last.timestamp || "",
  };
};
